import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary';
import { LoadableLazy } from '@confluence/loadable';

const EditionAwarenessLoadable = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EditionAwareness" */ './EditionAwareness'))
			.EditionAwareness,
});

export const EditionAwareness = withTransparentErrorBoundary({
	attribution: Attribution.GROWTH_TRANSMUTERS,
})(() => {
	return <EditionAwarenessLoadable />;
});
